import { combineReducers } from "redux";
import activeClientReducer from "./client-case/activeClientSlice";
import clientsReducer from "./clients/clientsSlice";
import documentReducer from "./documents/documentSlice";
import draftsReducer from "./drafts/draftsSlice";
import fileUploadReducer from "./file-upload/fileUploadSlice";
import formsReducer from "./forms/formsSlice";
import foreignNationalReducer from "./foreignNational/foreignNationalSlice";
import individualReducer from "./individual/individualSlice";
import lawyerReducer from "./lawyer/lawyerSlice";
import debuger from "./debug/debugSlice";

const rootReducer = combineReducers({
  lawyer: lawyerReducer,
  clients: clientsReducer,
  activeClient: activeClientReducer,
  foreignNational: foreignNationalReducer,
  individual: individualReducer,
  document: documentReducer,
  fileUpload: fileUploadReducer,
  drafts: draftsReducer,
  forms: formsReducer,
  debuger
});

export default rootReducer;

export type RootReducer = ReturnType<typeof rootReducer>;
